import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "revico-community-talk-reply-more-button-wrapper" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "revico-community-talk-reply-more-button",
      onClick: $setup.onclick,
      disabled: $props.isProcessingGetMoreReply
    }, _toDisplayString($props.moreButtonDisplayName), 9 /* TEXT, PROPS */, _hoisted_2)
  ]))
}